import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, Typography, Button, Grid, Box, IconButton, Divider,  TextField
} from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import Footer from '../components/SFooter';
import Header from '../components/Header';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import cartService from '../service/cartService';
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import Banner from '../components/Banner';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';
import BackToHome from "../components/BackToHome";




const Cart = () => {
  const navigate = useNavigate();
  const { cart, setCart, loadCartFromServer } = useCart();
    const { t } = useTranslation();
    const { user } = useAuth();

  const {
    email,
    name,
    familyName,
    givenName,
    userId,
    roles, 
    userTypes,
    partnerId,
    emailVerified,
    pincode
  } = user || {};
  

  useEffect(() => {
         
    if(!cart){
      loadCartFromServer();
    } 
    console.log(user);
  }, [cart]);
  
  const calculateTotal = () => {
    return cart.reduce((sum, item) => {
      const itemTotal = item.priceAtTimeOfAdd * item.quantity;
      const discountedPrice = item.discountAtTimeOfAdd;
      return sum + (itemTotal - discountedPrice);
    }, 0);
  };
  
     

  const calculateTotalDiscount = () => {
  return cart.reduce((sum, item) => {
    if (item.discountAtTimeOfAdd > 0) {
      return sum + item.discountAtTimeOfAdd;
    }
    return sum;
  }, 0);
};
  
      const calculateTax = () => {
  return cart.reduce((sum, item) => {
    if (item.taxAtTimeOfAdd > 0) {
      return sum + item.taxAtTimeOfAdd;
    }
    return sum;
  }, 0);
};

 // const GST_RATE = 0.18; // 18%
  let SHIPPING_COST = 50;

  const subtotal = calculateTotal();
  const gstAmount = calculateTax();
  if(subtotal>= 1500){
     SHIPPING_COST = 0;
  }
  const totalWithCharges = subtotal + gstAmount + SHIPPING_COST;
  const discountFee = calculateTotalDiscount();
  const grandTotal = totalWithCharges;
 /* const fetchCartItems = async () => {
    try {
      const response = cartService.getCarts(userId); //axios.get(`/api/cart/user/${userId}`);
      setCart(response.data);
    } catch (err) {
      console.error('Failed to fetch cart items', err);
    }
  };

  const handleRemoveItem = async (cartItemId) => {
    try {
      await axios.delete(`/api/cart/item/${cartItemId}`);
      setCart(prev => prev.filter(item => item.cartItemId !== cartItemId));
    } catch (err) {
      console.error('Error removing item:', err);
    }
  };

  const handleQuantityChange = async (cartItemId, newQty) => {
    const updatedCart = cart.map(item =>
      item.cartItemId === cartItemId ? { ...item, quantity: newQty } : item
    );
    setCart(updatedCart);

    try {
      await axios.put(`/api/cart/item/${cartItemId}`, { quantity: newQty });
    } catch (err) {
      console.error('Failed to update quantity', err);
    }
  };
  */
/*const handleAdd = async (cartItemId) => {
  setCart((prevCart) => {
    const updated = prevCart.map((item) =>
      item.cartItemId === cartItemId? { ...item, quantity: item.quantity + 1 }
        : item
    );
    localStorage.setItem('cart', JSON.stringify(updated));
    return updated;
  });

  const item = cart.find((p) => p.cartItemId === cartItemId);
  if (item) {
    const addToCartDTO = {
                userId: userId, // Replace with logged-in user ID
                productId: item.productId,
                quantity: item.quantity + 1
            };
    await cartService.addOrUpdateToCart(addToCartDTO);
  }
};*/
  
  const handleAdd = async (productId,variantId) => {
 
  const item = cart.find((p) => p.productVariantId === variantId);
  if (!item) return;

  const updatedCart = cart.map((p) =>
    p.productVariantId === variantId? { ...p, quantity: p.quantity + 1 }
      : p
  );

  setCart(updatedCart);
  localStorage.setItem('cart', JSON.stringify(updatedCart));
    const addToCartDTO = {
                userId: userId, // Replace with logged-in user ID
                productId: item.productId,
                quantity: 1,
                variantId: variantId
            };
  try{
  await cartService.addOrUpdateToCart(addToCartDTO);
   } catch (err) {
  if (err.response) {
    alert(err.response.data.message || "Bad Request");
  } else {
    alert("Network error");
  }
}     
    loadCartFromServer();
};

const handleRemove = async (productId, variantId) => {

  const item = cart.find((p) => p.productVariantId === variantId);
  if (!item) return;

  if (item.quantity > 1) {
    setCart((prevCart) => {
      const updated = prevCart.map((p) =>
        p.productVariantId === variantId? { ...p, quantity: p.quantity - 1 }
          : p
      );
      localStorage.setItem('cart', JSON.stringify(updated));
      return updated;
    });
      const addToCartDTO = {
                userId: userId, 
                productId: item.productId,
                quantity: -1,
               variantId: variantId
            };
    try{
    await cartService.addOrUpdateToCart(addToCartDTO);
    } catch (err) {
  if (err.response) {
    alert(err.response.data.message || "Bad Request");
  } else {
    alert("Network error");
  }
}
  } else {
    handleRemoveItem(productId, variantId);
  }
  loadCartFromServer();
};

const handleRemoveItem = async (productId, variantId) => {
  const item = cart.find((p) => p.productVariantId === variantId);
  if (!item) return;

  setCart((prevCart) => {
    const updated = prevCart.filter((p) => p.productVariantId !== variantId);
    localStorage.setItem('cart', JSON.stringify(updated));
    return updated;
  });
  
  const addToCartDTO = {
                userId: userId, 
                productId: item.productId,
                quantity: 0,
               variantId: variantId
            };

  try{
   await cartService.addOrUpdateToCart(addToCartDTO);

     } catch (err) {
  if (err.response) {
    alert(err.response.data.message || "Bad Request");
  } else {
    alert("Network error");
  }
}
  loadCartFromServer();
};

  const handleCheckout = async () => {
   
    if(pincode){
      
         const cartInfo = {
    cartId: cart[0].cartId,
    userId: userId,
    totalAmount: subtotal,
    taxAmount: gstAmount,
     shippingCost:SHIPPING_COST,
      grandTotal: grandTotal,
      discountTotal: discountFee
    };
    
    cartService.updateCartTotal(cartInfo);
       navigate('/delivery-slots');
    }else{
       navigate('/checkout');
    }
   
  };  

  return (
    <>
      <Header />
      <Container>
      <Typography variant="h4" sx={{ my: 3 }}>
       {t('my_sakz' , 'My Sakz')} 
      </Typography>

      {cart.length === 0 ? (
        <>
        <Box
        sx={{
          textAlign: "center",
          mt: 8,
          color: "text.secondary",
        }}
      >
        <ShoppingCartOutlinedIcon sx={{ fontSize: 80, color: "grey.500" }} />
        <Typography variant="h6" sx={{ mt: 2 }}>
           {t('your_cart_is_empty' , 'Your cart is empty')}  
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Looks like you haven’t added any items yet.
        </Typography>
        <Button variant="contained" color="primary" href="/">
         {t('browse_products' , 'Browse Products')}    
        </Button>
      </Box>

</>
      ) : (
        <>
          {/* Table-like cart items */}
          {cart.map((item) => (
            <React.Fragment key={item.productId}>
              <Grid container alignItems="center" spacing={2} sx={{ py: 2 }}>
                {/* Product Image & Name */}
                <Grid item xs={12} md={5}>
                  <Box display="flex" alignItems="center">
                    <img
                      // FIX: Use require() to dynamically import the image path
                      
                      src={`/images/${item.imageUrl || 'no_image.png'}`}
                      alt={item.productName}
                          onError={(e) => {
                              e.target.onerror = null; 
                              e.target.src = '/images/no_image.png';
                            }}
                      style={{ width: 80, height: 80, objectFit: 'cover', marginRight: 16 }}
                      
                    />
                    <Typography variant="body1">
                      {t(normalizeKey(item.productName) , item.productName)} / {t(normalizeKey(item.productVariantName) , item.productVariantName)} - {item.size}
                    </Typography>
                  </Box>
                </Grid>

                {/* Quantity Controls */}
                <Grid item xs={12} md={3}>
                  <Box display="flex" alignItems="center">
                    <IconButton onClick={() => handleRemove(item.productId, item.productVariantId)}>
                      <Remove />
                    </IconButton>
                    <Typography sx={{ mx: 2 }}>{item.quantity}</Typography>
                    <IconButton onClick={() => handleAdd(item.productId, item.productVariantId)}>
                      <Add />
                    </IconButton>
                  </Box>
                </Grid>

                {/* Subtotal for item */}
                <Grid item xs={12} md={2}>
                  <Typography variant="body1">
                    (₹{(item.priceAtTimeOfAdd).toFixed(2)})
                  </Typography>
                  
                 {item.discountAtTimeOfAdd > 0 && ( 
                 <>
                   <Typography variant="body1"  style={{ textDecoration: 'line-through' }}>
                    ₹{(item.priceAtTimeOfAdd * item.quantity).toFixed(2) }
                  </Typography>
                  
                    <Typography variant="body2" color="error">
                      
                      (-₹{(item.discountAtTimeOfAdd).toFixed(2)})off
                    </Typography>
                    </>
                  )}
                  <Typography variant="body1">
                    ₹{(((item.priceAtTimeOfAdd * item.quantity) - (item.discountAtTimeOfAdd)) || 0).toFixed(2)}
                  </Typography>
                </Grid>

                {/* Remove Button */}
                <Grid item xs={12} md={2}>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => handleRemoveItem(item.productId, item.productVariantId)}
                  >
                     {t('remove' , 'Remove')} 
                  </Button>
                </Grid>
              </Grid>
              <Divider />
            </React.Fragment>
          ))}

          {/* Totals Section */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6">{t('subtotal' , 'Subtotal')}: ₹{subtotal ? subtotal.toFixed(2) : '0.00'}</Typography>
            <Typography variant="body1" color="error">
               {t('you_saved' , 'You saved')} : ₹{calculateTotalDiscount().toFixed(2)}
            </Typography>
            <Typography variant="body1">{t('gst' , 'GST')} : ₹{gstAmount.toFixed(2)}</Typography>
            <Typography variant="body1">{t('shipping' , 'Shipping')}: ₹{SHIPPING_COST.toFixed(2)}</Typography>
            <Divider sx={{ my: 1 }} />
            <Typography variant="h5">{t('total' , 'Total')} : ₹{totalWithCharges.toFixed(2)}</Typography>
          </Box>

          {/* Checkout Button */}
          <Box sx={{ mt: 3 }}>
           <Button
              variant="contained"
              color="primary"
              onClick={handleCheckout}
            >
           
            {t('process_to_checkout' , 'Proceed to Checkout')}
              
            </Button>
          </Box>
               <BackToHome />
        </>
      )}
         <Banner />
      </Container>
      <Footer />
    </>
  );
};

        
export default Cart;
